<c-card *transloco="let t">
  <c-card-body>
    <c-container>

      <c-row>
        <c-col md="4">
          <h1>{{ t('Start/End Shift Reminders') }}</h1>
        </c-col>
        <c-col md="8">
          <c-row class="justify-content-end">
            <c-col xs="auto">

              <button color="light" cButton class="me-1" routerLink="/mgmt/shifts/shifts">
                <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                {{ t('Back to Shifts') }}
            </button>

            </c-col>
            <c-row class="justify-content-end">
              <c-col xs="auto" *ngIf="pagination.totalPages>1">

                <c-input-group  class="text-end">
                  <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                  <select aria-label="Default select example" name="page" cSelect (click)="updateFilter()"  [(ngModel)]="pagination.page">
                    <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                  </select>
                </c-input-group>

              </c-col>
              <c-col xs="auto">

                <c-input-group>
                  <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                  <select aria-label="Default select example" (click)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                    <option value="newest">{{ t('Newest') }}</option>
                    <option value="oldest">{{ t('Oldest') }}</option>
                    <option value="name">{{ t('Name') }}</option>
                  </select>
                </c-input-group>

              </c-col>
            </c-row>
          </c-row>
        </c-col>
      </c-row>

      <c-card class="mb-2">
        <c-card-body>

          <form cForm class="row row-cols-lg-auto g-3 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
            <c-col xs="auto">
              <label cLabel class="visually-hidden" for="search">
                {{ t('Search') }}
              </label>
              <c-input-group>
                <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
              </c-input-group>
            </c-col>

            <c-col xs="auto">
              <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Search') }}</button>
            </c-col>

          </form>

        </c-card-body>
      </c-card>

      <c-row *ngIf="shiftreminders">

      </c-row>
    </c-container>
  </c-card-body>
</c-card>
